import { BookmarkIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useGeckoAnalytics } from 'features/analytics'
import { useKestrel } from 'features/kestrelViewer'
import { KestrelCommands } from 'features/kestrelViewer/types/KestrelCommands'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React, { FC } from 'react'

export const CreateCameraViewButton: FC = () => {
  const { sendKVCommand, kestrelModel } = useKestrel()
  const { trackButtonClicked } = useGeckoAnalytics()

  const handleClick = () => {
    if (sendKVCommand) {
      sendKVCommand({
        command: KestrelCommands.NEW_CAMERA_VIEW,
      })
      trackButtonClicked({
        button_name: 'kestrel_create_camera_view',
        kestrel_model_id: kestrelModel?.data.kestrel_model_id,
      })
    }
  }

  return (
    <TooltipWrapper side={'right'} offset={5} label={'Save Camera View'}>
      <ViewToggle onClick={handleClick}>
        <BookmarkIcon width={22} height={22} />
      </ViewToggle>
    </TooltipWrapper>
  )
}
